export default function CTAFinal() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/images/cta-dfpro-2026.jpg"
          alt="Technicien DFPRO Hérault intervenant sur une baie coulissante"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-500/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
          Une baie coulissante qui coince ? Un volet en panne ?
        </h2>
        <p className="text-white/90 text-base md:text-lg font-body mb-8 max-w-xl mx-auto leading-relaxed">
          Nos techniciens interviennent <strong className="text-white font-semibold">sous 24 à 48h dans tout l'Hérault</strong>. Devis gratuit, sans engagement, et garantie 10 ans sur toutes nos réparations.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:+33980802242" className="btn-call text-base px-8 py-4">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line text-lg"></i>
            </span>
            Appeler le 09 80 80 22 42
          </a>
          <a href="tel:+33980802242" className="bg-white text-primary-500 font-heading font-semibold px-8 py-4 rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-background-100 inline-flex items-center justify-center gap-2 text-base">
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}